import OutsideClickHandler from "react-outside-click-handler";
import ReactDOM from "react-dom";
const PromotionDetail = ({ show, setShow }) => {
  return ReactDOM.createPortal(
    <div className="cdk-overlay-container">
      <div className="cdk-overlay-backdrop dialog-backdrop cdk-overlay-backdrop-showing" />
      <div
        className="cdk-global-overlay-wrapper"
        dir="ltr"
        style={{ justifyContent: "center", alignItems: "center" }}
      >
        <div
          id="cdk-overlay-1"
          className="cdk-overlay-pane dialog-panel"
          style={{ position: "static" }}
        >
          <app-dialog _nghost-serverapp-c33280995>
            <div _ngcontent-serverapp-c33280995 className="popup" id="dialog-1">
              <div
                _ngcontent-serverapp-c33280995
                className="popup__header"
              ></div>
              <div _ngcontent-serverapp-c33280995 className="popup__content">
                <app-promotion-info
                  _nghost-serverapp-c3747567219
                  className="ng-tns-c3747567219-993 ng-star-inserted"
                >
                  <OutsideClickHandler onOutsideClick={() => setShow({})}>
                    <div
                      _ngcontent-serverapp-c3747567219
                      className="pop-wrap promotion-pop new ng-tns-c3747567219-993 ng-trigger ng-trigger-popWrapTriggerAni show ani ng-star-inserted"
                    >
                      <a
                        onClick={() => setShow({})}
                        _ngcontent-serverapp-c3747567219
                        className="btn-close ng-tns-c3747567219-993"
                        style={{
                          maskImage: `url(${"/assets/NewIcon/icon-close.svg"})`,
                        }}
                      />
                      <div
                        _ngcontent-serverapp-c3747567219
                        className="detail-banner ng-tns-c3747567219-993 ng-star-inserted"
                      >
                        <img
                          _ngcontent-serverapp-c3747567219
                          className="ng-tns-c3747567219-993"
                          alt="image_253285"
                          src={`${process.env.REACT_APP_API_BASE_URL}${show?.descriptionImage}`}
                          loading="lazy"
                        />
                      </div>

                      <div
                        _ngcontent-serverapp-c3747567219
                        className="pop-title ng-tns-c3747567219-993 ng-star-inserted"
                      >
                        <h3
                          _ngcontent-serverapp-c3747567219
                          className="ng-tns-c3747567219-993"
                        >
                          {" "}
                          {show?.title}
                        </h3>
                      </div>
                      <div
                        _ngcontent-serverapp-c3747567219
                        className="pop-inner content-style ng-tns-c3747567219-993 ng-star-inserted"
                      >
                        <div
                          _ngcontent-serverapp-c3747567219
                          className="ng-tns-c3747567219-993"
                        >
                          <p
                            dir="ltr"
                            style={{
                              lineHeight: "1.38",
                              marginTop: "0pt",
                              marginBottom: "0pt",
                            }}
                          >
                            <b
                              id="docs-internal-guid-d571de6a-7fff-8142-37d3-76655356c628"
                              style={{ fontWeight: "normal" }}
                            >
                              <span
                                style={{
                                  fontSize: "11pt",
                                  fontFamily: "Arial, sans-serif",
                                  fontWeight: 400,
                                  fontStyle: "normal",
                                  fontVariant: "normal",
                                  textDecoration: "none",
                                  verticalAlign: "baseline",
                                  whiteSpace: "pre-wrap",
                                }}
                              >
                                {show?.description}
                              </span>
                            </b>
                            {/* <br />
                          <br />
                          <br /> */}
                            {/* <b
                            id="docs-internal-guid-d571de6a-7fff-8142-37d3-76655356c628"
                            style={{ fontWeight: "normal" }}
                          >
                            <span
                              style={{
                                fontSize: "11pt",
                                fontFamily: "Arial, sans-serif",
                                fontWeight: 700,
                                fontStyle: "normal",
                                fontVariant: "normal",
                                textDecoration: "none",
                                verticalAlign: "baseline",
                                whiteSpace: "pre-wrap",
                              }}
                            >
                              How To Join?
                            </span>
                          </b> */}
                          </p>
                        </div>
                      </div>
                    </div>
                  </OutsideClickHandler>
                  <div
                    _ngcontent-serverapp-c3747567219
                    className="pop-bg ng-tns-c3747567219-993 ng-trigger ng-trigger-popBgTriggerAni ng-star-inserted"
                    style={{ display: "block" }}
                  />
                </app-promotion-info>
              </div>
            </div>
          </app-dialog>
        </div>
      </div>
    </div>,
    document.getElementById("overlay"),
  );
};

export default PromotionDetail;
